import { useMemo } from 'react';

import type { UseAssetsParams as UseAssetsParamsBase } from '@apis/asset-data-service/queries/use-assets';
import type { GridSortModel } from '@packages/fenrir/components/datagrid';

import type { Filters } from '../../../assets/device-list/asset-filters/filters';

import { getFilterParam } from './get-filter-param/get-filter-param';
import { getSortParam } from './get-sort-param/get-sort-param';

export interface UseAssetsParamsProps
  extends Omit<UseAssetsParamsBase, 'sort'> {
  sort?: GridSortModel;
  filters: Filters;
}

export function useAssetsParams({
  sort,
  filters,
  ...rest
}: UseAssetsParamsProps): UseAssetsParamsBase {
  return useMemo(
    () => ({
      ...rest,
      sort: sort ? getSortParam(sort) : undefined,
      filter: getFilterParam(filters),
    }),
    [filters, rest, sort],
  );
}
